import InvitationStudent from '@/views/Invitation/Student/index.vue'
import InvitationOrder from '@/views/Invitation/Order/index.vue'

export default [
  {
    path: '/user/invitation-student',
    component: InvitationStudent,
    meta: { title: '邀请学生' },
  },
  {
    path: '/order/invitation-order',
    component: InvitationOrder,
    meta: { title: '邀请订单' },
  },
]
